import style from './Preloader.module.scss'

let Preloader = () => {
    return (
        <div className={style.content}>
            <div className={style.container__loader}>
                <div className={style.loader}></div>
            </div>
        </div>
    )
}

export default Preloader;